/**
 * Created by Ning Jiang on 1/19/2021.
 */

import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export interface IImageIntroPageConfig {
    texture: PIXI.Texture;
    position: PIXI.Point; // center
    scale: number;
}

export class ImageIntroPage extends SlideShowPage {

    constructor(config: IImageIntroPageConfig[]) {
        super(undefined, undefined);

        config.forEach((pageConfig) => {
            const image = new PIXI.Sprite(pageConfig.texture);
            image.anchor.set(0.5, 0.5);
            image.scale.set(pageConfig.scale);
            image.position.set(pageConfig.position.x, pageConfig.position.y);
            this.addChild(image);
        })
    }
}
